export default "__VITE_ASSET__c5biuyWh__"